jQuery( $ => {
	$( '.woocommerce-MyAccount-navigation-link.is-active' ).on( 'click', function() {
		$( this ).parent().toggleClass( 'open' );
	} );
} );
